import React from 'react'
import PropTypes from 'prop-types'
import Constants from 'scripts/base/Constants'
import GenericHeroIframe from 'scripts/components/article/HeroIframe/GenericHeroIframe'
import YoutubeHeroIframe from 'scripts/components/article/HeroIframe/YoutubeHeroIframe'
import VikiHeroIframe from 'scripts/components/article/HeroIframe/VikiHeroIframe'

const HeroIframe = (props) => {
  const { src } = props

  let heroVideoIframe
  if (src.search(Constants.VideoHostRegex.YOUTUBE) === 0) {
    heroVideoIframe = (
      <YoutubeHeroIframe src={ src } />
    )
  } else if (src.search(Constants.VideoHostRegex.VIKI) === 0) {
    heroVideoIframe = (
      <VikiHeroIframe src={ src } />
    )
  } else {
    heroVideoIframe = (
      <GenericHeroIframe src={ src }/>
    )
  }

  return heroVideoIframe
}

HeroIframe.propTypes = {
  src: PropTypes.string.isRequired
}

export default HeroIframe



// WEBPACK FOOTER //
// ./assets/js/components/article/HeroIframe/HeroIframe.jsx